// extracted by mini-css-extract-plugin
module.exports = {"jumpLinkList":"styles_jumpLinkList__3j_rb","jumpLinkList__item":"styles_jumpLinkList__item___QFWB","jumpLinkList__itemLink":"styles_jumpLinkList__itemLink__WKl6G"};